import { ComponentMap } from '@cinch-nx/data-storyblok'
import { CarsCarousel, GridRows } from '../molecule-blocks'
import { atomStoryblokComponents } from './atom-storyblok-components-map'

const moleculeStoryblokComponents: ComponentMap = {
  CarsCarousel,
  GridRows,
}

export const sharedStoryblokComponents: ComponentMap = {
  ...atomStoryblokComponents,
  ...moleculeStoryblokComponents,
}
